import { render, staticRenderFns } from "./replaceExamData.vue?vue&type=template&id=d72da91c&scoped=true"
import script from "./replaceExamData.vue?vue&type=script&lang=js"
export * from "./replaceExamData.vue?vue&type=script&lang=js"
import style0 from "./replaceExamData.vue?vue&type=style&index=0&id=d72da91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72da91c",
  null
  
)

export default component.exports